import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { GrDrag } from '../../node_modules/react-icons/gr/index.esm.js';
import Container from '../Container/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

function DraggableContent(props) {
  const {
    className,
    children,
    dropEffect = 'copy',
    onDragStart,
    onDragStop,
    value,
    name,
    headerActions,
    dragByContainer = false,
    ...containerProps
  } = props;
  const [draggable, setDraggable] = React.useState(false);
  const handleDragEnd = React.useCallback(e => {
    e.stopPropagation();
    setDraggable(false);

    if (onDragStop) {
      onDragStop(value);
    }
  }, [setDraggable, onDragStop, value]);
  React.useEffect(() => {
    window.addEventListener('mouseup', handleDragEnd);
    window.addEventListener('dragend', handleDragEnd);
    return () => {
      window.removeEventListener('mouseup', handleDragEnd);
      window.removeEventListener('dragend', handleDragEnd);
    };
  }, [handleDragEnd]);
  const handleDragStart = React.useCallback(e => {
    e.stopPropagation();
    const myValue = { ...value,
      $name: name
    };
    const data = JSON.stringify(myValue);
    e.dataTransfer.setData('text/plain', data);
    e.dataTransfer.dropEffect = dropEffect;

    if (onDragStart) {
      onDragStart(myValue);
    }
  }, [onDragStart, dropEffect, value, name]);
  const handleDragHandleMouseDown = React.useCallback(() => {
    setDraggable(true);
  }, [setDraggable]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, containerProps, {
    className: _cs(styles.draggableContent, className, dragByContainer && styles.drag),
    containerElementProps: {
      draggable,
      onDragStart: handleDragStart,
      onMouseDown: dragByContainer ? handleDragHandleMouseDown : undefined
    },
    headerActions: /*#__PURE__*/React.createElement(React.Fragment, null, headerActions, !dragByContainer && /*#__PURE__*/React.createElement("div", {
      role: "presentation",
      onMouseDown: handleDragHandleMouseDown,
      className: styles.dragContainer
    }, /*#__PURE__*/React.createElement(GrDrag, {
      className: styles.icon
    })))
  }), children);
}

var index = genericMemo(DraggableContent);

export { index as default };
//# sourceMappingURL=index.js.map
